import { TableCell, TableRow } from '@mui/material'
import { Delete } from '@mui/icons-material'
import styles from './places.module.scss'
import { FunctionComponent, useState } from 'react'
import { OccasionalSlotsPlaces } from '@/types/Slots'
import EditIcon from '@mui/icons-material/Edit'
import Desktop from '@/modules/desktopMobile/desktop'
import PlaceDialog from './Dialog/placeDialog'
import ValidDeletePlaceDialog from './Dialog/validDeletePlaceDialog.'

interface PlacesTableRowProps {
    place: OccasionalSlotsPlaces
    daycareId: number
    canUpdate: boolean
    updateOnePlace: (value: OccasionalSlotsPlaces) => void
    removeOnePlace: (placeId: number) => void
}

const PlacesTableRow: FunctionComponent<PlacesTableRowProps> = ({
    place,
    daycareId,
    canUpdate,
    updateOnePlace,
    removeOnePlace
}) => {
    const [isDeletePlaceDialogOpen, setDeletePlaceDialogOpen] = useState<boolean>(false)
    const [isUpdatePlaceDialogOpen, setUpdatePlaceDialogOpen] = useState<boolean>(false)

    return (
        <>
            <TableRow key={place.id}>
                <TableCell sx={{ width: '35%' }}>
                    <div className={styles.PlaceNameContainer}>{place.name}</div>
                </TableCell>
                <Desktop>
                    <TableCell sx={{ width: '55%' }}>{place.address}</TableCell>
                </Desktop>
                {canUpdate && (
                    <>
                        <TableCell>
                            <EditIcon className={styles.Icon} onClick={() => setUpdatePlaceDialogOpen(true)} />
                        </TableCell>
                        <TableCell>
                            <Delete className={styles.Icon} onClick={() => setDeletePlaceDialogOpen(true)} />
                        </TableCell>
                    </>
                )}
            </TableRow>
            <PlaceDialog
                daycareId={daycareId}
                isDialogOpen={isUpdatePlaceDialogOpen}
                handleCloseDialog={() => setUpdatePlaceDialogOpen(false)}
                updateOnePlace={updateOnePlace}
                create={false}
                place={place}
            />
            <ValidDeletePlaceDialog
                open={isDeletePlaceDialogOpen}
                handleClose={() => setDeletePlaceDialogOpen(false)}
                placeId={place.id}
                daycareId={daycareId}
                removeOnePlace={removeOnePlace}
            />
        </>
    )
}

export default PlacesTableRow
